module.exports = __webpack_public_path__ + "static/logo-63aec4f6d6dbe44a3bedd0afc69b9e0e.png";